module.exports = __webpack_public_path__ + "img/03-3-4数据功能.ba335627.svg";